import { ApiEnvironment } from '../../models/api-environment';

export class RoutingProfileServiceEnvironment extends ApiEnvironment {
  get routingProfilesUrl() {
    return `${this.baseUrl}/routingprofiles`;
  }

  get defaultRoutingProfilesUrl() {
    return `${this.routingProfilesUrl}/default`;
  }
}

export const routingProfileServiceEnvironment =
  new RoutingProfileServiceEnvironment();
